import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { green, red } from '@mui/material/colors'
import BlockIcon from '@mui/icons-material/Block'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import {
    Button,
    Container,
    Paper,
    Table,
    TableBody,
    TableContainer,
} from '@mui/material'
import {
    confirmStoreCredit,
    deleteStoreCredit,
    getOneStoreCredit,
} from '../../store/actions/storeCreditAction'
import { GET_ONE_STORE_CREDIT } from '../../store/types'
import Layout from '../../components/Layout'
import { CustomerItem } from '../Customer'
import { checkUserRole } from '../../common/checkUserRole'
import { roleListId, roleType } from '../../config/roleList'
import BasicModal from '../../components/modal/BasicModal'
import EditStoreCredit from '../../components/storeCredit/EditStgoreCredit'
import AppModal from '../../components/AppModal'

const ButtonGroup = ({ storeCredit }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    const [editOpen, setEditOpen] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const handleModelOpen = () => setModalOpen(true)
    const handleModalClose = () => setModalOpen(false)

    const handleDelete = useCallback(() => {
        dispatch(deleteStoreCredit(storeCredit.id, navigate))
    }, [dispatch, navigate, storeCredit.id])
    return (
        <div className="returnorder-button-group-container">
            {checkUserRole(
                userInfo,
                roleList,
                roleListId.STORE_CREDIT,
                roleType.EDIT
            ) &&
                !storeCredit.confirm && (
                    <>
                        <BasicModal open={editOpen} setOpen={setEditOpen}>
                            <EditStoreCredit
                                storeCredit={storeCredit}
                                setOpen={setEditOpen}
                            />
                        </BasicModal>
                        <Button
                            variant="outlined"
                            size="small"
                            style={{ marginTop: '10px' }}
                            onClick={() => setEditOpen(true)}
                        >
                            Edit Store Credit
                        </Button>
                    </>
                )}
            {checkUserRole(
                userInfo,
                roleList,
                roleListId.STORE_CREDIT,
                roleType.DELETE
            ) &&
                !storeCredit.confirm && (
                    <>
                        <AppModal
                            open={modalOpen}
                            cancelContent="Cancel"
                            submitContent="Delete"
                            title="Are you sure you want to delete this Return Order"
                            cancelClick={handleModalClose}
                            submitClick={handleDelete}
                            danger
                            handleClose={handleModalClose}
                        />
                        <Button
                            variant="outlined"
                            size="small"
                            color="error"
                            style={{ marginTop: '10px' }}
                            onClick={handleModelOpen}
                        >
                            Delete
                        </Button>
                    </>
                )}

            {checkUserRole(
                userInfo,
                roleList,
                roleListId.RETURN_ORDER,
                roleType.APPROVAL
            ) &&
                !storeCredit.confirm && (
                    <Button
                        variant="outlined"
                        color="success"
                        size="small"
                        style={{ marginTop: '10px' }}
                        onClick={() => {
                            if (window.confirm('Confirm Return Order?')) {
                                dispatch(confirmStoreCredit(storeCredit.id))
                            }
                        }}
                    >
                        Confirm
                    </Button>
                )}
        </div>
    )
}

const StoreCredit = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()
    const { storeCredit } = useSelector((state) => state.storeCredit)
    useEffect(() => {
        dispatch(getOneStoreCredit(id))
        return () => {
            dispatch({
                type: GET_ONE_STORE_CREDIT,
                payload: null,
            })
        }
    }, [dispatch, id])
    return (
        <Layout>
            <Container>
                <Button
                    style={{ marginBottom: '20px' }}
                    onClick={() => navigate('/store-credits')}
                >
                    Back
                </Button>
                {storeCredit && (
                    <>
                        <div>
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table">
                                    <TableBody>
                                        <CustomerItem
                                            title="Pay Type"
                                            value={storeCredit?.payType}
                                        />
                                        <CustomerItem
                                            title="Card No"
                                            value={storeCredit?.cardNo}
                                        />
                                        <CustomerItem
                                            title="Card Type"
                                            value={storeCredit?.cardType}
                                        />
                                        <CustomerItem
                                            title="Credit Amount"
                                            value={`$${storeCredit?.creditAmount}`}
                                        />
                                        <CustomerItem
                                            title="Credit Date"
                                            value={storeCredit?.creditDate}
                                        />
                                        <CustomerItem
                                            title="Ref No"
                                            value={storeCredit?.refNo}
                                        />
                                        <CustomerItem
                                            title="Message"
                                            value={storeCredit?.message}
                                        />

                                        <CustomerItem
                                            title="Confirm"
                                            value={
                                                storeCredit?.confirm ? (
                                                    <CheckCircleOutlineIcon
                                                        style={{
                                                            color: green[500],
                                                        }}
                                                    />
                                                ) : (
                                                    <BlockIcon
                                                        style={{
                                                            color: red[500],
                                                        }}
                                                    />
                                                )
                                            }
                                        />
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <ButtonGroup storeCredit={storeCredit} />
                        </div>
                    </>
                )}
            </Container>
        </Layout>
    )
}

export default StoreCredit
